import React, { useEffect, useState } from "react";

import {
    Typography,
    List,
    ListItem,
    IconButton,
    ListItemText,
    DeleteIcon,
    Tooltip,
    EditIcon,
    CopyAllIcon,
    LaunchIcon,
    Button,
    Box,
    ListItemAvatar,
    Avatar
} from "../../utils/ui";
import { ConfigListWrapper, ActionWrapper } from "./style";
import Constants from "../../utils/constants";

export default function ConfigList({ configList, addConfig, editConfig, cloneConfig, gotoTaskList, deleteConfig, teams }) {

    const addNewSpace = () => {
        window.location.href = `https://app.clickup.com/api?client_id=${Constants.CREDENTIALS.CLIENT_ID}&redirect_uri=${Constants.REDIRECTION_URL}`
    }

    const teamsList = teams.map(team => team.id);

    const colors = ['green', 'red', 'blue', 'lightRed', 'yellow', 'grey']
    return (
        <ConfigListWrapper>
            <div className="headingWrapper">
                <Typography variant="h6" component="div">
                    Config Lists
                </Typography>
                <Box>
                    <Button className="submitBtn" size="large" variant="outlined" onClick={addConfig}>
                        Add New
                    </Button>
                    <Button className="submitBtn" size="large" variant="outlined" onClick={addNewSpace} sx={{ ml: 2 }}>
                        Edit Workspaces
                    </Button>
                </Box>
            </div>
            <div className="listContainer">
                <List dense={false}>
                    {configList.map((config, index) => (
                        teamsList.includes(config.team.id) ?
                            <ListItem
                                key={index}
                                secondaryAction={
                                    <ActionWrapper>
                                        <div className="buttonWrapper">
                                            <Tooltip title="Edit">
                                                <IconButton edge="end" aria-label="Edit" onClick={() => editConfig(index)}>
                                                    <EditIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        <div className="buttonWrapper">
                                            <Tooltip title="Clone">
                                                <IconButton edge="end" aria-label="copy" onClick={() => cloneConfig(index)}>
                                                    <CopyAllIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        <div className="buttonWrapper">
                                            <Tooltip title="Open">
                                                <IconButton edge="end" aria-label="open" onClick={() => gotoTaskList(index)}>
                                                    <LaunchIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        <div className="buttonWrapper">
                                            <Tooltip title="Delete">
                                                <IconButton edge="end" aria-label="delete" onClick={() => deleteConfig(index)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </ActionWrapper>
                                }
                            >
                                <ListItemAvatar>
                                    {config.team.avatar ? <Avatar alt={config.team.name} src={config.team.avatar} /> : <Avatar alt={config.team.name} sx={{background: colors[Math.round(Math.random(5))]}}>{config.team.name[0]}</Avatar>}
                                </ListItemAvatar>
                                <ListItemText
                                    primary={config.name}
                                    secondary={`${config.list.name} (${config.team.name})`}
                                />
                            </ListItem>

                            : null
                    ))}
                </List>
            </div>
        </ConfigListWrapper>
    )
}